module.exports = __webpack_public_path__ + "img/zhxy_image_17.8758c70c.png";